<template>
  <div class="row">
    <div class="span8 detail-main">
      <h1 class="post-title">{{ content.article_title }}</h1>
      <div class="post-meta">
        <span>🕐 {{ content.article_createtime | dataFormat }}</span>
        <span>作者：<author-pop :author="content"></author-pop></span>
        <span>{{ commentnum }} Comments</span>
        <span>👁 66</span>
      </div>
      <blockquote class="post-body" v-html="content.article_content" style="margin: 0;"></blockquote>
      <div style="margin: 24px 0; text-align: center;">
        <el-button round disabled>👍 66</el-button>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <news-widget />
    </div>
    <div class="span8">
      <comment-widget />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import carouselWidget from '@/components/carousel.vue'
import newsWidget from '@/components/news.vue'
import commentWidget from '@/components/comment.vue'
import authorPop from '@/components/authorpop.vue'
import { getArticleContent } from '@/api'

export default {
  name: 'NewsContent',
  components: { carouselWidget, newsWidget, commentWidget, authorPop },
  props: { id: { type: String, default: '' } },
  data() {
    return { content: {} }
  },
  computed: {
    ...mapState({ commentnum: (s) => s.commentnum })
  },
  watch: {
    id: { immediate: true, handler() { this.getcontent() } }
  },
  methods: {
    getcontent() {
      if (!this.id) return
      getArticleContent(this.id).then((res) => {
        this.content = res.data || {}
        this.$store.dispatch('setcontentid', this.id)
        this.$store.dispatch('setcontentinfo', { name: this.content.article_title, userid: this.content.user_id })
      })
    }
  }
}
</script>
